var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgXin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#1EB5FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.405 7.151l-3.63 1.61a.673.673 0 00-.35.59v12.98a.66.66 0 00.36.59l3.63 1.57a.338.338 0 00.5-.3V7.451a.35.35 0 00-.51-.3zM9.02 8.741l-3.52-1.6a.338.338 0 00-.5.3v16.74a.341.341 0 00.52.29l3.54-1.87a.667.667 0 00.32-.57v-12.7a.7.7 0 00-.36-.59zm11.04 4.43l-3.79-2.17a.668.668 0 00-.67 0l-3.86 2.15a.684.684 0 00-.34.59v4.4c0 .243.13.468.34.59l3.86 2.22c.207.12.463.12.67 0l3.79-2.2a.684.684 0 00.34-.59v-4.4a.672.672 0 00-.34-.59z",
    fill: "#FFF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXin);
export default __webpack_public_path__ + "static/media/xin.0a574d07d4454ec92f45950ae7e08cd8.svg";
export { ForwardRef as ReactComponent };